import { useEffect } from "react";

export default function useScrollAnimation() {
    useEffect(() => {
        const items = document.querySelectorAll(".fade-in");

        const reveal = () => {
            const trigger = window.innerHeight * 0.85;
            items.forEach((el) => {
                const top = el.getBoundingClientRect().top;
                if (top < trigger) el.classList.add("show");
            });
        };

        window.addEventListener("scroll", reveal);
        reveal();
        return () => window.removeEventListener("scroll", reveal);
    }, []);
}
